
/*
  This file is auto-generated by generate-icon-components.js. Do not edit it manually.
*/
import { html, css, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";

export const FhiIconCircleCheckBigSelector = "fhi-icon-circle-check-big";

/**
 * ## FhiIconCircleCheckBig
 * 
 * {@link https://designsystem.fhi.no/?path=/docs/ikoner--docs}
 * 
 * @tag fhi-icon-circle-check-big
 * @element fhi-icon-circle-check-big
 */
@customElement(FhiIconCircleCheckBigSelector)
export class FhiIconCircleCheckBig extends LitElement {

  /**
   * Sets the color for the icon.
   * Should preferably be a color token. See [Color Tokens](https://designsystem.fhi.no/?path=/docs/design-tokens-farger--docs)
   * @type {string}
   */ 
  @property({ type: String }) color: string = "currentcolor";

  /**
   * Sets the size of the icon. Can be one of the predefined sizes, a number value, rem or px.
   * Number values are treated as px.
   * @type { 'xsmall' | 'small' | 'medium' | 'large' | number | string}
   */
  @property({ type: String }) size: 'xsmall' | 'small' | 'medium' | 'large' | number | `${number}px` | `${number}rem` = 'medium';

  private get _size(): string {
    switch (this.size) {
      case 'xsmall': 
        return '1rem'; 
      case 'small':
        return '1.25rem';
      case 'medium':
        return '1.5rem'; 
      case 'large':
        return '2rem'; 
      default:
        if (String(this.size).endsWith('px') || String(this.size).endsWith('rem')) {
          return String(this.size);
        }
        if (isNaN(Number(this.size))) {
          console.warn(`Invalid size value: ${this.size}. Falling back to default size '1.5rem'.`)
          return '1.5rem';
        }
        return `${this.size}px`;
    }
  }

  render() {
    return html`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="${this._size}" height="${this._size}" fill="${this.color}"><path d="M9.63 1.509a10.75 10.75 0 0 1 6.345.497l.4.169.068.035a.75.75 0 0 1-.607 1.362l-.072-.027-.343-.146A9.25 9.25 0 1 0 21.25 12v-.92a.75.75 0 1 1 1.5 0V12l-.009.435A10.751 10.751 0 1 1 9.631 1.509m11.896 1.909A.75.75 0 0 1 22.53 4.53l-10 10a.75.75 0 0 1-1.06 0l-3-3-.052-.056a.75.75 0 0 1 1.055-1.056l.057.052L12 12.94l9.47-9.47z"/></svg>
    `;
  }
      
  static styles = css`
    :host {
      display: flex;
      max-height: min-content;
      max-width: min-content;
    }
  `;
  }
